export enum TaskListEnum {
  AIRWORTHINESSDIRECTIVESTATUS = "AIRWORTHINESS DIRECTIVE STATUS",
  MPD = "Task MPD List Status",
  REPAIRDAMAGE = "Repair Damage List",
  SBMOD = "SB MOD List",

}
